import {createAsyncThunk, createEntityAdapter, createSlice} from "@reduxjs/toolkit";
import {toast} from "react-toastify";
import {
    addWhyYouLoveItApi, deleteWhyYouLoveItApi,
    getWhyYouLoveItApi,
    updateWhyYouLoveItApi
} from "../../../services/manage-product/setting/whyYouLoveItService";


export const getAllWhyYouLoveIt = createAsyncThunk('whyYouLoveIt/getWhyYouLoveIt', async (filters, {dispatch}) => {
    const response = await getWhyYouLoveItApi(filters);
    return response.response;
});

const buildWhyYouLoveItFormData = (data) => {
    const formData = new FormData();
    formData.append('title', data.title);
    if (data.icon && data.icon.length > 0) {
        formData.append('icon', data.icon[0]);
    }
    return formData;
};

export const addWhyYouLoveIt = createAsyncThunk('whyYouLoveIt/addWhyYouLoveIt', async (whyYouLoveIt, {
    dispatch,
    getState
}) => {
    try {
        const response = await addWhyYouLoveItApi(buildWhyYouLoveItFormData(whyYouLoveIt));
        const data = await response.response;
        dispatch(getAllWhyYouLoveIt());
        toast.success("Add item successfully", {
            position: toast.POSITION.TOP_RIGHT,
        });
        return data;
    } catch (e) {

        return Promise.reject(e);
    }
});

export const updateWhyYouLoveIt = createAsyncThunk('whyYouLoveIt/updateWhyYouLoveIt', async (whyYouLoveIt, {
    dispatch,
    getState
}) => {
    try {
        const response = await updateWhyYouLoveItApi(buildWhyYouLoveItFormData(whyYouLoveIt), whyYouLoveIt.id);
        const data = await response.response;
        dispatch(getAllWhyYouLoveIt());
        toast.success("Update item successfully", {
            position: toast.POSITION.TOP_RIGHT,
        });
        return data;
    } catch (e) {

        return Promise.reject(e);
    }
});

export const deleteWhyYouLoveIt = createAsyncThunk('whyYouLoveIt/deleteWhyYouLoveIt', async (id, {
    dispatch,
    getState
}) => {
    try {
        const response = await deleteWhyYouLoveItApi(id);
        const data = await response.response;
        dispatch(getAllWhyYouLoveIt());
        toast.success("Delete item successfully", {
            position: toast.POSITION.TOP_RIGHT,
        });
        return data;
    } catch (e) {

        return Promise.reject(e);
    }
});

const whyYouLoveItAdapter = createEntityAdapter({});

export const {selectAll: selectWhyYouLoveIt, selectById: selectWhyYouLoveItById} = whyYouLoveItAdapter.getSelectors(
    state => state.product.whyYouLoveIt
);

const whyYouLoveItSlice = createSlice({
    name: 'whyYouLoveIt',
    initialState: whyYouLoveItAdapter.getInitialState({
        searchText: '',
        addDialog: {
            component: 'whyYouLoveIt',
            type: 'new',
            props: {
                open: false
            },
            data: null
        },
    }),
    reducers: {
        selectWhyYouLoveItSearchText: {
            reducer: (state, action) => {
                state.searchText = action.payload;
            },
            prepare: event => ({payload: event.target.value || ''})
        },
        openNewDialog: (state, action) => {
            state.addDialog = {
                component: 'whyYouLoveIt',
                type: 'new',
                props: {
                    isOpen: true
                },
                data: null
            };
        },
        openEditDialog: (state, action) => {
            state.addDialog = {
                type: 'edit',
                props: {
                    isOpen: true
                },
                data: action.payload
            };
        },
        closeEditDialog: (state, action) => {
            state.addDialog = {
                type: 'edit',
                props: {
                    isOpen: false
                },
                data: null
            };
        },
    },
    extraReducers: {
        [getAllWhyYouLoveIt.fulfilled]: whyYouLoveItAdapter.setAll
    }
});

export const {
    selectWhyYouLoveItSearchText, openNewDialog,
    closeNewDialog,
    openEditDialog,
    closeEditDialog
} = whyYouLoveItSlice.actions;

export default whyYouLoveItSlice.reducer;
